import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { OwaDate } from 'owa-datetime';
import { freeBusyCache, FreeBusyType } from 'owa-freebusy-cache';

export default function hasUnknownFreeBusyAttendee(
    allAttendeeTypes: AttendeeType[],
    start: OwaDate,
    end: OwaDate,
    isAllDayEvent: boolean,
    calendarEvent: CalendarEvent
): boolean {
    // GetUserAvailability is not supported for consumers.
    // VSO 37516: GetUserAvailability should not be issued at all for consumer scenario
    if (isConsumer()) {
        return true;
    }

    // Go through all attendee types in calendar event to see if there is any attendee that has unknown free busy info
    let hasUnknownFreeBusyAttendee = false;
    for (let i = 0; i < allAttendeeTypes.length; i++) {
        const attendee = allAttendeeTypes[i].Mailbox.EmailAddress;
        const aggregatedFreeBusyType: FreeBusyType = freeBusyCache.getAggregatedFreeBusy(
            attendee,
            start,
            end,
            isAllDayEvent,
            calendarEvent
        );

        // There is unknown free busy type in case getUserAvailability is pending or failed for any attendee
        if (
            aggregatedFreeBusyType === FreeBusyType.NoData ||
            aggregatedFreeBusyType === FreeBusyType.Loading
        ) {
            hasUnknownFreeBusyAttendee = true;
            break;
        }
    }

    return hasUnknownFreeBusyAttendee;
}
